<template>
    <div class="modal fade" tabindex="-1" aria-labelledby="clientModalLabel" :id="id">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content border-0 shadow-lg">
                <!-- ヘッダー -->
                <div class="modal-header bg-primary bg-gradient text-white border-0 py-3">
                    <h5 class="modal-title fw-bold" id="clientModalLabel">
                        <i :class="client.id ? 'fa-solid fa-pen-to-square' : 'fa-solid fa-circle-plus'" class="me-2"></i>
                        {{ client.id ? '取引先編集' : '新規取引先作成' }}
                    </h5>
                    <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <!-- ボディ -->
                <div class="modal-body p-4">
                    <!-- グローバルエラー -->
                    <div v-if="error.global" class="alert alert-danger d-flex align-items-center mb-4" role="alert">
                        <i class="fa-solid fa-triangle-exclamation me-2"></i>
                        <div>{{ error.global }}</div>
                    </div>

                    <!-- 基本情報セクション -->
                    <div class="mb-4">
                        <h6 class="text-muted text-uppercase fw-semibold mb-3 pb-2 border-bottom">
                            <i class="fa-solid fa-building me-2"></i>基本情報
                        </h6>
                        
                        <div class="row g-3">
                            <!-- 取引先名 -->
                            <div class="col-md-8">
                                <label for="clientName" class="form-label fw-semibold">
                                    取引先名<span class="text-danger ms-1">*</span>
                                </label>
                                <input
                                    id="clientName"
                                    type="text"
                                    class="form-control form-control-lg"
                                    v-model="client.client_name"
                                    :class="{'is-invalid': error.client_name}"
                                    placeholder="株式会社サンプル"
                                    required
                                    data-error-key="client_name"
                                >
                                <div v-if="error.client_name" class="invalid-feedback">
                                    {{ error.client_name }}
                                </div>
                            </div>

                            <!-- 頭文字 -->
                            <div class="col-md-4">
                                <label for="initial" class="form-label fw-semibold">頭文字</label>
                                <input
                                    id="initial"
                                    type="text"
                                    class="form-control form-control-lg text-center"
                                    v-model="client.initial"
                                    :class="{'is-invalid': error.initial}"
                                    placeholder="サ"
                                    maxlength="2"
                                    data-error-key="initial"
                                >
                                <div v-if="error.initial" class="invalid-feedback">
                                    {{ error.initial }}
                                </div>
                            </div>

                            <!-- フリガナ -->
                            <div class="col-md-12">
                                <label for="clientNameKana" class="form-label fw-semibold">
                                    フリガナ<span class="text-danger ms-1">*</span>
                                </label>
                                <input
                                    id="clientNameKana"
                                    type="text"
                                    class="form-control"
                                    v-model="client.client_name_kana"
                                    :class="{'is-invalid': error.client_name_kana}"
                                    placeholder="カブシキガイシャサンプル"
                                    required
                                    data-error-key="client_name_kana"
                                >
                                <div v-if="error.client_name_kana" class="invalid-feedback">
                                    {{ error.client_name_kana }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 識別情報セクション -->
                    <div class="mb-3">
                        <h6 class="text-muted text-uppercase fw-semibold mb-3 pb-2 border-bottom">
                            <i class="fa-solid fa-hashtag me-2"></i>識別情報
                        </h6>
                        
                        <div class="row g-3">
                            <!-- 取引先コード -->
                            <div class="col-md-6">
                                <label for="clientCode" class="form-label fw-semibold">取引先コード</label>
                                <div class="input-group">
                                    <span class="input-group-text bg-light">
                                        <i class="fa-solid fa-barcode"></i>
                                    </span>
                                    <input
                                        id="clientCode"
                                        type="text"
                                        class="form-control"
                                        v-model="client.client_code"
                                        :class="{'is-invalid': error.client_code}"
                                        placeholder="9876"
                                        data-error-key="client_code"
                                    >
                                    <div v-if="error.client_code" class="invalid-feedback">
                                        {{ error.client_code }}
                                    </div>
                                </div>
                            </div>

                            <!-- インボイス登録番号 -->
                            <div class="col-md-6">
                                <label for="invoiceNumber" class="form-label fw-semibold">
                                    登録番号（インボイス）
                                </label>
                                <div class="input-group">
                                    <span class="input-group-text bg-light">
                                        <i class="fa-solid fa-file-invoice"></i>
                                    </span>
                                    <input
                                        id="invoiceNumber"
                                        type="text"
                                        class="form-control"
                                        v-model="client.invoice_number"
                                        :class="{'is-invalid': error.invoice_number}"
                                        placeholder="T1234567890123"
                                        data-error-key="invoice_number"
                                    >
                                    <div v-if="error.invoice_number" class="invalid-feedback">
                                        {{ error.invoice_number }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- フッター -->
                <div class="modal-footer bg-light border-0 py-3">
                    <button type="button" class="btn btn-outline-secondary px-4" @click="close">
                        <i class="fa-solid fa-xmark me-2"></i>キャンセル
                    </button>
                    <button type="button" class="btn btn-primary px-4 shadow-sm" @click="save">
                        <i class="fa-solid fa-check me-2"></i>保存
                    </button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'ClientsEditor',
    props: {
        id: {
            default: 'clients-editor'
        },
        client_id: {
            default: null
        }
    },
    data() {
        return {
            client: {},
            error: {},
        };
    },
    methods: {
        close() {
            this.$emit('close', this.id);
        },
        reload() {
            if (!this.client_id) {
                this.client = {};
                return;
            }
            axios.get(`/api/master/client?id=${this.client_id}`).then(res => {
                this.client = res.data;
            }).catch(err => {Alert.err(err)});
        },
        validate() {
            this.error = {};
            if (!this.client.client_code) this.error.client_code = '取引先コードは必須です。';
            if (!this.client.client_name) this.error.client_name = '取引先名は必須です。';
            if (!this.client.client_name_kana) this.error.client_name_kana = 'フリガナは必須です。';
            return Object.keys(this.error).length === 0;
        },
        save() {
            if (!this.validate()) { return; }

            axios.post('/api/master/client', this.client).then(() => {
                Alert.msg("保存しました。");
                this.$emit('saved');
                this.close();
            }).catch(e => {
                Alert.err(e.response);
            });
        }
    },
    mounted() {
        $(`#${this.id}`).on("show.bs.modal", (e) => {
            this.reload();
        });
    }
}
</script>
